import { render, staticRenderFns } from "./messagebox.vue?vue&type=template&id=a760cf90&scoped=true&"
import script from "./messagebox.vue?vue&type=script&lang=js&"
export * from "./messagebox.vue?vue&type=script&lang=js&"
import style0 from "./messagebox.vue?vue&type=style&index=0&id=a760cf90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a760cf90",
  null
  
)

export default component.exports